var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgGoogleCalendar = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26135_40008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.816 5.68429L13.1318 5.05273L6.18441 5.68429L5.55273 12.0001L6.18429 18.316L12.5001 19.1055L18.816 18.316L19.4475 11.8423L18.816 5.68429Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.77525 15.4828C8.30317 15.1638 7.97629 14.6981 7.79785 14.0823L8.89369 13.6307C8.99317 14.0097 9.16681 14.3033 9.41473 14.5118C9.66109 14.7202 9.96109 14.8228 10.3116 14.8228C10.6701 14.8228 10.978 14.7138 11.2353 14.4959C11.4925 14.278 11.6221 14.0001 11.6221 13.6638C11.6221 13.3197 11.4863 13.0385 11.2147 12.8207C10.9432 12.6029 10.6021 12.4938 10.1947 12.4938H9.56161V11.4092H10.1299C10.4805 11.4092 10.7758 11.3145 11.0158 11.125C11.2558 10.9355 11.3758 10.6766 11.3758 10.3466C11.3758 10.0529 11.2684 9.81916 11.0537 9.64396C10.839 9.46876 10.5673 9.38032 10.2373 9.38032C9.91525 9.38032 9.65941 9.46564 9.46993 9.63772C9.28045 9.8098 9.14305 10.0214 9.05629 10.2708L7.97161 9.81928C8.11525 9.41188 8.37901 9.05188 8.76577 8.74084C9.15265 8.4298 9.64681 8.27344 10.2468 8.27344C10.6905 8.27344 11.0899 8.35876 11.4437 8.53084C11.7973 8.70292 12.0753 8.94136 12.2758 9.24448C12.4763 9.54916 12.5758 9.89032 12.5758 10.2692C12.5758 10.656 12.4827 10.9828 12.2963 11.2512C12.1099 11.5197 11.881 11.7249 11.6094 11.8686V11.9333C11.9679 12.0833 12.2599 12.3123 12.4905 12.6202C12.7194 12.9281 12.8346 13.296 12.8346 13.7255C12.8346 14.155 12.7257 14.5386 12.5077 14.875C12.2898 15.2114 11.9883 15.4766 11.6062 15.6692C11.2225 15.8618 10.7915 15.9597 10.3131 15.9597C9.75889 15.9612 9.24733 15.8018 8.77525 15.4828Z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4996 10.0448L14.3027 10.9148L13.7012 10.0022L15.8596 8.44531H16.687V15.789H15.4996V10.0448Z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8159 24L24.5 18.3159L21.6579 17.0527L18.8159 18.3159L17.5527 21.1579L18.8159 24Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9209 21.1585L6.18402 24.0006H18.8156V18.3164H6.18402L4.9209 21.1585Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.39468 0C1.34792 0 0.5 0.84792 0.5 1.89468V18.3157L3.34208 19.5788L6.18416 18.3157V5.68416H18.8157L20.0788 2.84208L18.8158 0H2.39468Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 18.3164V22.1059C0.5 23.1528 1.34792 24.0006 2.39468 24.0006H6.18416V18.3164H0.5Z",
    fill: "#188038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8154 5.685V18.3166H24.4996V5.685L21.6575 4.42188L18.8154 5.685Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4996 5.68416V1.89468C24.4996 0.8478 23.6517 0 22.6049 0H18.8154V5.68416H24.4996Z",
    fill: "#1967D2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26135_40008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGoogleCalendar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Google_Calendar.6317ba1c.svg";
export { ForwardRef as ReactComponent };